import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';

import { RedirectionCallbackComponent } from './redirection-callback/redirection-callback.component';
import { RedirectionService } from './redirection/redirection.service';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { StoreModule } from '@ngrx/store';
import { featureKey, reducers } from './store';
import { EffectsModule } from '@ngrx/effects';
import { RedirectionEffects } from './store/effects/redirection.effects';

const routes: Route[] = [
  {
    path: '',
    component: RedirectionCallbackComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKey, reducers),
    EffectsModule.forFeature([RedirectionEffects]),
    LoadersModule,
    UtilsModule,
    RouterModule.forChild(routes),
  ],
  declarations: [RedirectionCallbackComponent],
  providers: [RedirectionService],
})
export class RedirectionModule {}
